<template>
<div class="CmdOperation">
    <template v-if="space == '26001'">
        <el-button v-for="cmd of cmd26001List" :key="cmd.key"
            class="cmd-btn" type="primary" @click="sendCmdByKey(cmd.key)">{{$t(/*cmd.label*/'command.26001.' + cmd.key)}}</el-button>
    </template>
    <template v-else-if="space == '26003'">
        <el-button v-for="cmd of cmd26003List" :key="cmd.key"
            class="cmd-btn" type="primary" @click="sendCmdByName(cmd)">{{$t(/*cmd.label*/'command.26003.' + cmd.key)}}</el-button>
        <el-button v-for="cmd of cmd26003ComplexList" :key="cmd.key"
            class="cmd-btn" type="primary" @click="handleDialogShow(cmd)">{{$t(/*cmd.label*/'command.26003.' + cmd.key)}}</el-button>
    </template>
    <template v-else-if="space == '26004'">
        <el-button v-for="cmd of cmd26004List" :key="cmd.key"
            class="cmd-btn" type="primary" @click="sendCmdByName(cmd)">{{$t(/*cmd.label*/'command.26004.' + cmd.key)}}</el-button>
        <el-button v-for="cmd of cmd26004ComplexList" :key="cmd.key"
            class="cmd-btn" type="primary" @click="handleDialogShow(cmd)">{{$t(/*cmd.label*/'command.26004.' + cmd.key)}}</el-button>
    </template>
    <template v-if="space == '26005'">
        <CustomRead :uid='uid' :id='id' :space='space'/>
        <el-button v-for="cmd of cmd26005GetList" :key="cmd.key"
            class="cmd-btn" type="primary" @click="sendCmdByName(cmd)">{{$t(/*cmd.label*/'command.26005.' + cmd.key)}}</el-button>
        <el-button v-for="cmd of cmd26005SetList" :key="cmd.key"
            class="cmd-btn" type="primary" @click="handleDialogShow(cmd)">{{$t(/*cmd.label*/'command.26005.' + cmd.key)}}</el-button>
    </template>
    <template v-else-if="space == '26007'">
        <el-button v-for="cmd of cmd26004List" :key="cmd.key"
            class="cmd-btn" type="primary" @click="sendCmdByName(cmd)">{{$t(/*cmd.label*/'command.26007.' + cmd.key)}}</el-button>
        <el-button v-for="cmd of cmd26004ComplexList" :key="cmd.key"
            class="cmd-btn" type="primary" @click="handleDialogShow(cmd)">{{$t(/*cmd.label*/'command.26007.' + cmd.key)}}</el-button>
    </template>

    <el-dialog :visible.sync="dialogShow" :title="$t(`command.${space}.${currCmd.key}`)" width="500px" class="CmdOperationDialog">
        <div class="dialog-container">
            <div class="form-item" v-for="item of currCmd.params" :key="item.key">
                <div class="key" v-if="item.label">{{$t(item.label)}}</div>
                <div class="value">
                    <template v-if="item.type === 'input'">
                        <el-input v-model="item.value" :placeholder="$t('c.input') + $t(item.label)" />
                    </template>
                    <template v-if="item.type === 'number'">
                        <el-input-number v-model="item.value" :controls='false' :placeholder="$t('c.input') + $t(item.label)" :min="0" :max="item.max" />
                    </template>
                    <template v-if="item.type === 'checkbox'">
                        <el-checkbox-group v-model="item.value" class="checkbox-box">
                            <el-checkbox v-for='(i,index) of item.option' :key='index' :label="i.value" class="checkbox-item">{{$t(i.label)}}</el-checkbox>
                        </el-checkbox-group>
                    </template>
                    <template v-if="item.type === 'radio'">
                        <el-radio-group v-model="item.value">
                            <el-radio v-for='(i,index) of item.option' :key='index' :label="i.value" >{{$t(i.label)}}</el-radio>
                        </el-radio-group>
                    </template>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogShow = false">取 消</el-button>
            <el-button type="primary" @click="handleDialogSubmit" :loading="loading">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import Core from '../../../core'
import {stringToArrayBuffer, hexToArrayBuffer, arrayBufferToHex} from '../../../core/js/utils'

import BKV from '@/core/bkv/bkv'
import {encodeNumber} from '@/core/bkv/bkv'

export default {
    components: {
        CustomRead: () => import('./CustomRead.vue'),
    },
    props: {
        uid: { type: [String] },
        id:  { type: [String, Number] },
        space: { type: [String, Number] },
        detail: { type: Object, default: () => {}},
    },
    data() {
        return {
            cmd26001List: [
                { key:'GET_GPS',    label:'获取GPS数据' },
                { key:'GET_STATUS', label:'获取⻋辆状态' },
                { key:'GET_BMS',    label:'获取BMS信息' },
                { key:'CHECK_VEHICLE', label:'⻋辆检测' },
                { key:'CHECK_BMS',     label:'BMS检测' },
                { key:'CHECK_METER',   label:'仪表检测' },
                { key:'CHECK_ECU',     label:'ECU检测' },
                { key:'CHECK_CONTROLLER', label:'控制器检测' },
                { key:'LOCK',   label: '设防' },
                { key:'UNLOCK', label: '解防' },
                { key:'UNLOCK_SEAT',     label: '开坐垫锁' },
                { key:'UNLOCK_TAIL_BOX', label: '打开尾箱' },
                { key:'BOOT',     label: '启动⻋辆' },
                { key:'SHUTDOWN', label: '关闭⻋辆' },
                { key:'REBOOT',   label: '远程重启硬件' },
            ],

            cmd26003List: [
                { type: 'set', label: '设置车辆点火/熄火', key: 'launch', params: [
                    { key: 'launch_status', label: [/*点火*/'turn_on', /*熄火*/'turn_off'], type: 'flag'}
                ]},
                { type: 'get', label: '重启', key: 'reboot'},
                { type: 'get', label: '检测', key: 'check'},

                { type: 'get', label: '查询GSM/GPS状态', key: 'getGsmGpsStatus'},
                { type: 'get', label: '获取位置', key: 'getLocation'},
                { type: 'get', label: '获取历史位置', key: 'getHistoryLocation'},
                { type: 'get', label: '获取电池状态', key: 'getBattery'},

                { type: 'set', label: '设置BMS信息', key: 'setBMS',params: [
                    { key: 'index', label: /*请设置index*/'please_input_index',type: 'input'},
                    { key: 'config', label: /*请设置BMS信息*/'please_input_bms_info',type: 'input'},
                    { key: 'timeout', label: /*请设置超时时间*/'please_input_time_out_period',type: 'input'},
                ]},
                { type: 'set', label: '设置服务端地址', key: 'setServerAddr', params: [
                    { key: 'addr', type: 'input'}
                ]},

                { type: 'get', label: '获取设防状态', key: 'getGuard'},
                { type: 'set', label: '设置设防状态', key: 'setGuard', params: [
                    { key: 'guard_status', label: [/*设防*/'defenses', /*不设防*/'undefenses'], type: 'flag'}
                ]},

                { type: 'get', label: '获取锁状态', key: 'getLock'},
                { type: 'set', label: '设置锁状态', key: 'setLock', params: [
                    { key: 'lock_status', label: [/*加锁*/'lock', /*解锁*/'unlock'], type: 'flag'}
                ]},

                { type: 'get', label: '获取心跳间隔', key: 'getHeartbeatInterval'},
                { type: 'set', label: '设置心跳间隔', key: 'setHeartbeatInterval', params: [
                    { key: 'heartbeat_interval', type: 'input'}
                ]},

                { type: 'get', label: '获取APN', key: 'getAPN'},
                { type: 'set', label: '设置APN', key: 'setAPN', params: [
                    { key: 'apn', type: 'input'}
                ]},

                { type: 'get', label: '获取定位周期', key: 'getLocateInterval'},
                { type: 'set', label: '设置定位周期', key: 'setLocateInterval', params: [
                    { key: 'acc_on_interval', label: /*请设置ACC ON上报频率*/'please_input_acc_on_interval', type: 'input'},
                    { key: 'acc_off_interval', label: /*请设置ACC OFF上报频率*/'please_input_acc_off_interval', type: 'input'}
                ]},
                { type: 'get', label: '获取部件信息', key: 'getModuleInfo'},
                { type: 'get', label: '获取里程', key: 'getMileage'},
            ],
            cmd26003ComplexList: [
                { type: 'set', label: '设置HMI参数', key: 'setHmiParams', params: [
                    { value: undefined, type: 'number', min: 0, max: 10, key: 'rear_wheel_speed_ratio', label: /*后轮转速系数*/'device.rear_wheel_speed_ratio' },
                    { value: undefined, type: 'number', min: 0, max: 10, key: 'front_wheel_speed_ratio', label: /*前轮转速系数*/'device.front_wheel_speed_ratio' },
                    { value: undefined, type: 'number', min: 0, max: 10, key: 'drive_ratio', label: /*转动系数*/'device.drive_ratio' },
                    { value: undefined, type: 'number', min: 0, max: 10, key: 'remaining_mileage_ratio', label: /*剩余里程系数*/'device.remaining_mileage_ratio' },
                ]},
                { type: 'set', label: '设置BMS参数', key: 'setBmsParams', params: [
                    { value: undefined, type: 'number', min: 0, max: 1000, key: 'cut_off_voltage_threshold', label: /*截止电压*/'device.cut_off_voltage_threshold' },
                    { value: undefined, type: 'number', min: 0, max: 1000, key: 'over_voltage_protect_threshold', label: /*过压保护*/'device.over_voltage_protect_threshold' },
                    { value: undefined, type: 'number', min: 0, max: 1000, key: 'over_current_protect_threshold', label: /*限流保护*/'device.over_current_protect_threshold' },
                ]},
                { type: 'set', label: '设置MCU参数', key: 'setMcuParams', params: [
                    { value: undefined, type: 'number', min: 0, max: 1000, key: 'leak_voltage_protect_threshold', label: /*欠压保护*/'device.leak_voltage_protect_threshold' },
                    { value: undefined, type: 'number', min: 0, max: 1000, key: 'over_current_protect_threshold', label: /*限流保护*/'device.over_current_protect_threshold' },
                    { value: undefined, type: 'number', min: 0, max: 1000, key: 'over_voltage_protect_threshold', label: /*过压保护*/'device.over_voltage_protect_threshold' },
                    { value: undefined, type: 'number', min: 0, max: 250,  key: 'motor_pole_pair_count', label: /*电机极对数*/'device.motor_pole_pair_count' },
                    { value: undefined, type: 'number', min: 0, max: 250,  key: 'reverse_charge_current', label: /*反向充电电流设置*/'device.reverse_charge_current' },
                ]},
            ],

            cmd26004List: [],
            cmd26004ComplexList: [],

            cmd26005GetList: [
                { type: 'get', label: '获取信息1', key: 'getInfo1'},
                { type: 'get', label: '获取信息2', key: 'getInfo2'},
                { type: 'get', label: '获取信息3', key: 'getInfo3'},
            ],
            cmd26005SetList: [
                { value: 0xE5, format: 'string', len: 20, label: '设置GPRS APN', key: 'set_gprs_apn', params: [
                    { value: undefined, len: 20, format: 'string', label: /*设置GPRS APN*/'device.gprs_apn', type: 'input', },
                ]},
                { value: 0xE6, format: 'bytes', len: 5, label: '设置蓝牙连接密码', key: 'set_bluetooth_password', params: [
                    { value: undefined, start: 0, len: 1, format: 'hex', label: /*状态*/'c.status', type: 'radio', option: [{value: '01', label: /*开启*/'c.open'}, {value: '00', label: /*关闭*/'c.close'}], },
                    { value: undefined, start: 1, len: 4, format: 'string', label: /*密码*/'user.password', type: 'number', max: 9999 },
                ]},
                { value: 0x78, format: 'bytes', len: 33, label: '设置模块接入参数', key: 'set_module_access_parameters', params: [
                    { value: undefined, start: 0, len: 1,  format: 'hex', label: /*目标*/'c.target', type: 'radio', option: [{value: '00', label: /*设置服务端地址*/'command.26005.set_server_addr'}, {value: '01', label: /*设置运维服务器地址*/'command.26005.set_OM_server_addr'}], },
                    { value: undefined, start: 1, len: 27, format: 'string', label: 'IP', type: 'input', },
                    { value: undefined, start: 28, len: 5, format: 'string', label: 'PORT', type: 'input', },
                ]},
                { value: 0x79, format: 'uint8', len: 1, label: '激活模块升级', key: 'activate_module_upgrade', params: [
                    { value: undefined, len: 1,  format: 'hex', label: /*类型*/'c.type', type: 'radio', option: [{value: '00', label: /*模块升级*/'command.26005.module_upgrade'}, {value: '01', label: /*BMS升级*/'command.26005.bms_upgrade'}], },
                ]},
                { value: 0x80, format: 'uint16', len: 1, label: '配置电池', key: 'set_battery', params: [
                    { value: [], len: 1,  format: 'hex', vw: '100%', type: 'checkbox', option: [
                        { value: '00', label: /*USB输出(RW)*/'command.26005.usb_power' },
                        { value: '01', label: /*尾灯(RW)*/'command.26005.light_status' },
                        { value: '02', label: /*充电器识别状态(RO)*/'command.26005.charger_indentify_status' },
                        { value: '03', label: /*充电器连接状态(RO)*/'command.26005.charger_connection' },
                        { value: '04', label: /*预充电路(RO)*/'command.26005.pre_charge_circuit' },
                        { value: '05', label: /*预放电路(RO)*/'command.26005.pre_discharge_circuit' },
                        { value: '06', label: /*放电 MOS (RW)*/'command.26005.discharge_mosfet' },
                        { value: '07', label: /*充电 MOS(RW)*/'command.26005.charge_mosfet' },
                        { value: '17', label: /*电池停止充电状态*/'command.26005.battery_charging_stopped_flag' },
                    ]},
                ]},
                { value: 0x81, format: 'bytes', len: 10, label: '设置电子围栏', key: 'set_electronic_fence', params: [
                    { value: undefined, start: 0, len: 2, format: 'number', littleEndian: true, label: /*围栏半径*/'device.fence_radius', type: 'number', rate: 1, max: 65536},
                    { value: undefined, start: 2, len: 4, format: 'number', littleEndian: true, label: /*经度*/'c.longitude', type: 'number', rate: 1000000, max: 360},
                    { value: undefined, start: 6, len: 4, format: 'number', littleEndian: true, label: /*纬度*/'c.latitude',  type: 'number', rate: 1000000, max: 360},
                ]},
            ],

            cmd26007GetList: [],
            cmd26007SetList: [],

            loading: false,
            dialogShow: false,
            currCmd: {},
        }
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {},
    methods: {
        async sendCmdByName(cmd) {
            let apiName = 'Fengine' + this.space
            console.log('sendCmdByName apiName', apiName, 'cmd:', cmd)
            let params = {}
            if (cmd.type === 'set') {
                for (const item of cmd.params) {
                    let tip = this.$t(/*请*/'c.please') + this.$t(/*cmd.label*/`command.${this.space}.` + cmd.key)
                    switch (item.type) {
                        case 'input':
                            tip = item.label ? this.$t('command.26003.' + item.label) : tip
                            try {
                                let {value} = await this.$prompt(tip, this.$t(/*提示*/'c.tip'), {
                                    confirmButtonText: this.$t(/*确定*/'c.confirm'),
                                    cancelButtonText: this.$t(/*取消*/'c.cancel'),
                                })
                                if (!value) {
                                    return this.$message.warning(tip)
                                } else {
                                    params[item.key] = value
                                }
                            } catch (err) { return }
                            break;
                        case 'flag':
                            let btnText = {
                                distinguishCancelAndClose: true,
                                confirmButtonText: this.$t('command.26003.' + item.label[0]),
                                cancelButtonText: this.$t('command.26003.' + item.label[1]),
                            }
                            try {
                                await this.$confirm(tip, this.$t(/*提示*/'c.tip'), btnText)
                                params[item.key] = 1
                            } catch (err) {
                                if (err !== 'cancel') { return }
                                params[item.key] = 0
                            }
                            break;
                    }
                }
            }
            console.log('sendCmdByName params:', params)
            Core.Api[apiName][cmd.key]({
                id: this.uid,
                uid: this.uid,
                ...params
            }).then(res => {
                console.log("sendCmd res", res);
                this.$message.success(this.$t(/*操作成功*/'c.oper_success'))
            })
        },
        sendCmdByKey(key) {
            console.log('sendCmdByKey key', key)
            Core.Api.Fengine26001.sendCmd({id: this.uid, uid: this.uid, cmd: key}).then(res => {
                console.log("sendCmd res", res);
                this.$message.success(this.$t(/*操作成功*/'c.oper_success'))
            })
        },

        handleDialogShow(cmd) {
            this.currCmd = Core.Util.deepCopy(cmd)
            this.dialogShow = true
            this.loading = false;
        },
        handleDialogSubmit() {
            console.log('handleDialogSubmit')
            switch (this.space) {
                case '26003': this.sendComplexCmd(); break;
                case '26005': this.sendCmdByBKV(); break;
            }
        },
        // 发送 经过bkv组包后的指令
        async sendCmdByBKV() {
            let c = Core.Util.deepCopy(this.currCmd)
            let b = new BKV();
            let target

            if (c.key === 'set_battery') {
                console.log('format: set_battery')
                let arr = c.params[0].value
                arr = arr.map(item => item.split(''))
                let value = new Uint8Array(2)
                arr.forEach(item => {
                    let index = parseInt(item[0])
                    let i = parseInt(item[1])
                    value[index] = Core.Util.setBit(value[index], i)
                });
                target = new Uint16Array(value)
            } else if (c.format !== 'bytes') {
                console.log('format: string or uint8')
                let value = c.params[0].value
                switch (c.format) {
                    case 'string':
                        if (!value) { return this.$message.warning('请完善下发内容') }
                        if (value.length > c.len) { return this.$message.warning(`仅支持${c.len}长度内的字符`) }
                        target = stringToArrayBuffer(value, c.len)
                        break;
                    case 'uint8':
                        if (!value) { return this.$message.warning('请完善下发内容') }
                        target = hexToArrayBuffer(value)
                        break;
                }
            } else {
                console.log('format: bytes')
                target = new Uint8Array(c.len)
                const view = new DataView(target.buffer);
                for (const item of c.params) {
                    let v = item.value
                    console.log('v:', v)
                    if (!v) { return this.$message.warning('请完善下发内容') }
                    if (item.type === 'number' && !Number(v)) { return this.$message.warning(`${$t(item.label)}仅支持[0-9]的数字`) }
                    switch (item.format) {
                        case 'hex':
                            target.set(hexToArrayBuffer(v), item.start)
                            break;
                        case 'number':
                            v = parseFloat(v)
                            if (v > item.max) {
                                return this.$message.warning(`${$t(item.label)}仅支持小于${item.max}的数字`)
                            }
                            switch (item.len) {
                                case 1:
                                    view.setUint8(item.start, v*item.rate)
                                    break;
                                case 2:
                                    view.setUint16(item.start, v*item.rate, item.littleEndian)
                                    break;
                                case 4:
                                    view.setUint32(item.start, v*item.rate, item.littleEndian)
                                    break;
                            }

                            break;
                        case 'string':
                            v = v.toString()
                            if (v.length > item.len) { return this.$message.warning(`${$t(item.label)}仅支持${c.len}长度内的字符`) }
                            target.set(stringToArrayBuffer(v, item.len), item.start)
                            break;
                    }
                }
            }
            console.log('target:', target)

            this.loading = true;
            b.addByNumberKey(0x01, hexToArrayBuffer('83'));
            b.addByNumberKey(c.value, target);
            let apiName = 'Fengine' + this.space
            console.log('arrayBufferToHex(b.pack()):', arrayBufferToHex(b.pack()))
            // return
            Core.Api[apiName].sendCmd({
                id: this.uid,
                bkv: arrayBufferToHex(b.pack()),
            }).then(() => {
                this.$message.success(this.$t(/*操作成功*/'c.oper_success'));
                this.dialogShow = false
                this.currCmd = {}
            }).catch(err => {
                console.log('sendCmdByBKV err:', err);
                this.loading = false;
            })

        },

        // 发送 复杂输入的 写入指令
        sendComplexCmd() {
            let cmd = Core.Util.deepCopy(this.currCmd)
            console.log('sendComplexCmd cmd:', cmd)

            let params = {}
            for (const item of cmd.params) {
                if (item.value === undefined) {
                    return this.$message.warning(this.$t('c.input') + this.$t(item.label))
                }
                params[item.key] = item.value
            }
            console.log('sendComplexCmd params:', params)
            let apiName = 'Fengine' + this.space
            Core.Api[apiName][cmd.key]({
                id: this.uid,
                ...params
            }).then(res => {
                console.log("sendComplexCmd res", res);
                this.$message.success(this.$t(/*操作成功*/'c.oper_success'))
                this.dialogShow = false
            })

        }
    },
}
</script>

<style lang='scss' scoped>
.CmdOperation {
    .cmd-btn {
        width: 150px;
        margin-left: 20px;
        margin-bottom: 12px;
    }
    .checkbox-item {
        width: calc(50% - 30px);
        margin-bottom: 6px;
    }
}
.CmdOperationDialog {
    .form-item {
        .key {
            word-break: normal;
            white-space: pre-line;
            line-height: 1;
            &::before {
                display: none;
            }
        }
    }
}
</style>